import { useGoogleMap, allEvents, months } from "./App.js";
import { useRef, useEffect } from 'react';

const InfoWindow = ({ lat, lon, event, events = [], onShow }) => {
	const infomap = useGoogleMap();
	const divRef = useRef(null);
	const overlayView = useRef(null);
	const today = new Date();
	const pricingUnit = localized_params.price_unit;

	let first_draw = false;
	let fpRef = null;

	window.clearActiveMarker = () => {
		onShow(null);
	};

	window.setActive = (marker) => {
		onShow(null);
		onShow(marker);
	};

	useEffect(() => {
		if (!infomap) {
			return;
		}

		const overlay = new window.google.maps.OverlayView();

		overlay.onAdd = () => {
			const div = document.createElement('div');
			let html = ``;

			if (events.length) {
				html = `
					<div class='wtrmap-card wtrmap-info wtrmap-info-multiple'>
						<div class="wtrmap-info-close" onclick="window.clearActiveMarker()">+</div>
						<h3 class="wtrmap-card-title">${events[0].city}</h3>`;
				events.forEach((event) => {
					const startMonth = months[event.startDate.getMonth()];
					const endMonth = months[event.endDate.getMonth()];

					html += `<button class="wtrmap-multiple-button" onclick='window.setActive("` + event.ID + `")'>View event on<br>` + startMonth + ` ` + event.startDate.getDate() + `-` + (startMonth != endMonth ? endMonth + ' ' : '') + event.endDate.getDate() + `, ` + event.startDate.getFullYear() + `</button>`;
				});
				html += `</div>`
			} else {
				const startMonth = months[event.startDate.getMonth()];
				const endMonth = months[event.endDate.getMonth()];

				const closed = event.status == 'closed';
				const earlyBird = event.early_bird_price && event.earlyDate >= today;
				const SALE = Boolean(event.sale_price);

				html = `
					<div class="wtrmap-card wtrmap-info ${closed ? 'wtrmap-card-closed' : ''}${earlyBird ? ' wtrmap-card-earlybird' : ''}${SALE ? ' wtrmap-card-sale' : ''}">
						<div class="wtrmap-info-close" onclick="window.clearActiveMarker()">+</div>

						<h3 class="wtrmap-card-title">${event.title}</h3>

						<div class="wtrmap-card-icon wtrmap-card-date">
							${startMonth} ${event.startDate.getDate()}-${startMonth != endMonth ? endMonth + ' ' : ''}${event.endDate.getDate()}, ${event.startDate.getFullYear()}
						</div>

						<div class="wtrmap-card-icon wtrmap-card-location">
							<div class="wtrmap-card-hotel">${event.location}</div>
							<div class="wtrmap-card-city-state">${event.city}, ${event.state}</div>
						</div>

						<div class="wtrmap-card-icon wtrmap-card-prices">
							<span class="wtrmap-card-price wtrmap-card-price-regular">$${event.price} ${pricingUnit}</span>
							${earlyBird ? `<span class="wtrmap-card-price wtrmap-card-price-earlybird">$${event.early_bird_price} ${pricingUnit}</span>` : ``}
							${SALE ? `<span class="wtrmap-card-price wtrmap-card-price-sale">$${event.sale_price} ${pricingUnit}</span>` : ``}
						</div>

						<a href="${event.link}" target="_blank" class="wtrmap-card-button">${closed ? 'View Event Details' : 'Register Today'}</a>

					</div>
				`;
			}

			div.innerHTML = html;

			div.style.position = 'absolute';
			divRef.current = div;
			fpRef = overlay.getPanes().floatPane;
			fpRef.appendChild(div);
			first_draw = true;
		};

		overlay.draw = () => {
			const div = divRef.current;
			const point = overlay
				.getProjection()
				.fromLatLngToDivPixel({ lat: parseFloat(lat), lng: parseFloat(lon) });
			if (point) {
				div.style.left = point.x + 28 + 'px';
				div.style.top = point.y - 33 - (div.offsetHeight / 2) + 'px';
			}
			if (first_draw) { // Pan to show overlay only after the first draw
				overlay.panTo();
				first_draw = false;
			}
		};

		overlay.panTo = () => {
			const container = infomap.getDiv();
			const div = divRef.current;
			let pad = 20;
			let icon = 40;
			let c = {};
			let d = {};
			let p = {};
			p.x = 0;
			p.y = 0;
			c.w = container.offsetWidth;
			c.h = container.offsetHeight;
			d.w = div.offsetWidth;
			d.h = div.offsetHeight;
			d.x1 = div.offsetLeft + c.w / 2 - pad - icon;
			d.y1 = div.offsetTop + c.h / 2 - pad;
			d.x2 = div.offsetLeft + c.w / 2 + d.w + pad;
			d.y2 = div.offsetTop + c.h / 2 + d.h + pad;
			if (d.x1 < 0 || d.w > c.w) {
				p.x = d.x1;
			} else if (d.x2 > c.w) {
				p.x = d.x2 - c.w;
			}
			if (d.y1 < 0 || d.h > c.h) {
				p.y = d.y1;
			} else if (d.y2 > c.h) {
				p.y = d.y2 - c.h;
			}
			infomap.panBy(p.x, p.y);
		}

		overlay.onRemove = () => {
			if (divRef.current) {
				fpRef.removeChild(divRef.current);
			}
		};

		overlay.setMap(infomap);
		overlayView.current = overlay;

		return () => {
			overlayView.current.setMap(null);
		};
	}, [infomap]);
};

export { InfoWindow };
